export default {
  getMarketingActivity: '/v3/mallcenter/getMarketingActivity',
  queryMarketingActivitySaleList: '/v3/mallcenter/queryMarketingActivitySaleList'
}
